import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource'
import WorkspaceAppResource from './WorkspaceAppResource'
import Engine from "@milestoneslabs/milestones-js-engine";
import isEmpty from 'lodash/isEmpty';
import UserAppResource from "./UserAppResource";
import AgentContactAppResource from "./AgentContactAppResource";
import OrganizationAppResource from "./OrganizationAppResource";

export const RETRY_FAILED = 'retry_failed';
export const RETRY_SUCCESS = 'retry_success';

class MoveHubAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Move-Hub'
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'moves/hubs'
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ])
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'enabled',
            'hubUuid',
            'claimUrl',
            'transaction',
            'invite',
            'consumer_user_uuid',
            'consumer_contact_uuid',
            'agent_organization_member_uuid',
            'agent_uuid',
            'claimed',
            'isFailed',
            'clicked',
        ]
    }

    /**
     * @returns {{hub: WorkspaceAppResource}}
     */
    relationMap() {
        return {
            hub: WorkspaceAppResource,
            user: UserAppResource,
            contact: AgentContactAppResource,
            agentUser: UserAppResource,
            organizationMember: OrganizationAppResource
        }
    }

    /**
     * @returns {{hub: string}}
     */

    relationForeignKeys() {
        return {
            hub: 'hub_uuid',
            user: 'consumer_user_uuid',
            contact: 'consumer_contact_uuid',
            agentUser: 'agent_uuid',
            organizationMember: 'agent_organization_member_uuid'
        }
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            enabled: {
                type: 'boolean',
            },
            hubUuid: {
                type: 'string',
            },
            claimUrl: {
                type: 'string',
            },
            organizationMemberUuid: {
                type: 'string',
            },
            consumerUserUuid: {
                type: 'string',
            },
            consumerContactUuid: {
                type: 'string',
            },
            agentUuid: {
                type: 'string',
            },
            claimed: {
                type: 'boolean',
            },
            isFailed: {
                type: 'boolean',
            },
            clicked: {
                type: 'boolean',
            },
        }
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            launch: Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/launch'),
            createTransaction: Engine.apiUrl(this.appResourceApiPrefix() + '/createTransaction'),
            invite: Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/invite'),
        };
    }

    async launch(data = {}) {
        if (this.uuid === null) {
            return Promise.resolve(null)
        }
        const url = this.apiPaths().launch.replace('{uuid}', this.uuid);
        const apiResponse = await Engine.post(url, data);

        if (isEmpty(apiResponse.resources) ||
            !apiResponse.resources.has(this.uuid)) {
            return Promise.resolve(null)
        }

        this.syncFromRemoteAppResource(apiResponse.resources.get(this.uuid))

        return apiResponse;
    }

    async createTransaction(data) {
        const url = this.apiPaths().createTransaction;
        return await Engine.post(url, data);
    }

    async fetchInvite() {
        if (this.uuid === null) {
            return Promise.resolve(null)
        }
        const url = this.apiPaths().invite.replace('{uuid}', this.uuid);
        const apiResponse = await Engine.get(url);

        if (isEmpty(apiResponse.resources) ||
            !apiResponse.resources.has(this.uuid)) {
            return Promise.resolve(null)
        }

        this.syncFromRemoteAppResource(apiResponse.resources.get(this.uuid))

        return apiResponse;
    }
}

export default MoveHubAppResource
